import React, { useEffect, useState } from "react";
import Badge from "../UI/Badge";
import MessageModal from "../Modal/MessageModal";
import { ChevronsUpDown, MessageSquareText, EllipsisVertical, Trash2 } from "lucide-react";
import BulkMessageSendModal from "../Modal/BulkMessageSendModal";
import { account_name, can_visit, exchangeDate, location_name, usPhoneFormat } from "../../helpers";
import { Link } from "react-router-dom";
import DeleteModal from "../Modal/DeleteModal";
import Skeleton from "react-loading-skeleton";
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function MIPSDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    checkedIds = [],
    setCheckedIds = () => {},
    checkSelected = false,
    reloadData = () => {},
    reloadDataFilter = {},
    messageTemplate = [],
    account_id,
    location_id,
    smsLimit,
    setSmsLimit = () => {},
    dataLoading,
    setDataLoading = () => {},
    globalCheckedIds,
    setGlobalCheckedIds,
    selectedPatientData,
    setSelectedPatientData = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    mipsBulkDelete = false,
    setMipsBulkDelete = () => {},
    handleDeleteRecord = () => {},
  } = props;

  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [activeModal, setActiveModal] = useState(false);  
  const [mipsData, setMipsData] = useState({});
  const [orderBy, setOrderBy] = useState();
    const [deleteRecord, setDeleteRecord] = useState({});
    const [activeDeleteModal, setActiveDeleteModal] = useState(false);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };
  
  const handleSendMessageModal = (data) => {
    setMipsData(data)
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  const removeSelection = () => {
    setSelectedPatientData([]);
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const handleDelete = (item) => {
    setDeleteRecord(item);
    setActiveDeleteModal(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const buttonArray = [
    { label: 'Send message', icon: MessageSquareText, isButton: true, action: handleSendMessageModal },
    { label: 'Delete', icon: Trash2, isButton: true, action: handleDelete },
  ];
  const permissions = {
    showButton1: false,
    showButton2: can_visit('mips_delete'),
  };


  return (
    <>
      {checkSelected && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            {/* {can_visit("_bulk_message") && (
              <BulkMessageSendModal
                // checkedIds={checkedIds}
                messageTemplate={messageTemplate}
                account_id={account_id}
                location_id={location_id}
                smsLimit={smsLimit}
                setSmsLimit={setSmsLimit}
                checkedIds={Array.from(globalCheckedIds)}
                setGlobalCheckedIds={setGlobalCheckedIds}
                selectedPatientData={selectedPatientData}
                setSelectedPatientData={setSelectedPatientData}
              />
            )} */}

            {(can_visit('mips') && can_visit('mips_delete')) && (
              <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color"
                onClick={() => {
                  setMipsBulkDelete(!mipsBulkDelete);
                  setPreviousScrollPosition(window.scrollY);
                  window.scrollTo(0, 0);
                }}
              >
                <Trash2 width={20} height={20} />
                Delete
              </button>
            )}

            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Patients</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      )}
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div
                  className="docpro_checkbox"
                  style={{ top: "3px" }}
                >
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("name");
                }}
                className={orderBy === "name" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Date of Birth <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("sex");
                }}
                className={orderBy === "sex" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Gender <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("mobile_phone");
                }}
                className={
                  orderBy === "mobile_phone" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>MIPS</th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData && tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox">
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>

                    {can_visit("_role_enterprise") && (
                      <>
                        <td> {item?.account_id ? account_name(item?.account_id) : ''} </td>
                        <td> {item?.location_id ? location_name(item?.location_id) : ''} </td>
                      </>
                    )}

                    <td className="bulk">
                      <div className="flex items-center table_img">
                        <img src={item?.gender === "Male" ? maleAvatar : item?.gender === "Female" ? femaleAvatar : otherAvatar} alt="User" />
                        {item?.full_name}
                      </div>
                    </td>

                    <td> {item?.dob ? exchangeDate(item?.dob) : ''} </td>
                    <td> {item?.gender} </td>
                    <td className="bulk">
                      {item?.mobile_phone ? usPhoneFormat(item?.mobile_phone) : ''}
                    </td>
                    <td>
                      {item?.mips && typeof item?.mips === 'object' && Object.keys(item?.mips)?.length > 0 && (
                        Object.entries(item?.mips)?.map(([name, status], idx) => (
                          <p key={idx} style={{ marginBottom: '3px' }}>
                            <span style={{ marginRight: '4px' }}>
                              <Badge color={status === "Eligible" ? "red" : "Not Eligible" ? "green" : ""}>
                                {status}
                              </Badge>
                            </span>
                            <span>{name}</span>
                          </p>
                        ))
                      )}
                    </td>
                    <td className="bulk hidden">
                      {item?.id}
                    </td>
                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        {buttonArray
                          .filter((_, index1) => permissions[`showButton${index1 + 1}`])
                          .slice(0, 2)
                          .map((btn, btnIndex) => (
                            <div key={btnIndex}>
                              {btn.isButton ? (
                                <button type="button" className="docpro_icon_btn" onClick={() => btn.action(item)}>
                                  <btn.icon width={18} height={18} />
                                  <span className="docpro_tip">{btn.label}</span>
                                </button>
                              ) : (
                                <Link to={`${btn.action}?patient_id=${item.id}`}>
                                  <button type="button" className="docpro_icon_btn">
                                    <btn.icon width={18} height={18} />
                                    <span className="docpro_tip">{btn.label}</span>
                                  </button>
                                </Link>
                              )}
                            </div>
                          ))
                        }
                        {buttonArray?.length > 2 &&
                          buttonArray.filter((_, index2) => permissions[`showButton${index2 + 1}`]).length > 2 && (
                            <div className="dropdown-container relative">
                              <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                                <EllipsisVertical width={18} height={18} />
                              </button>
                              {viewStatusOptions[index] && (
                                <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                  {buttonArray
                                    .filter((_, index2) => permissions[`showButton${index2 + 1}`])
                                    .slice(2)
                                    .map((btn, btnIndex) => (
                                      <div key={btnIndex}>
                                        {btn.isButton ? (
                                          <button
                                            type="button"
                                            className="docpro_icon_btn docpro_dropdown_button"
                                            onClick={() => btn.action(item)}
                                          >
                                            <btn.icon width={18} height={18} />
                                            <span>{btn.label}</span>
                                          </button>
                                        ) : (
                                          <Link to={`${btn.action}?patient_id=${item.id}`}>
                                            <button type="button" className="docpro_icon_btn docpro_dropdown_button">
                                              <btn.icon width={18} height={18} />
                                              <span>{btn.label}</span>
                                            </button>
                                          </Link>
                                        )}
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          )
                        }
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan={`${can_visit("_role_enterprise") ? 9 : 7}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageModal
          patient_id={mipsData.id}
          fullName={mipsData?.full_name}
          phone={mipsData?.mobile_phone ? usPhoneFormat(mipsData?.mobile_phone) : ''}
          messageTemplate={messageTemplate}
          tooltip={true}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.full_name}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
